export default {"src":"/_next/static/media/Biglogo.ed5972f5.svg","height":362,"width":280,"blurWidth":0,"blurHeight":0};